import { useLocation } from "react-router-dom";
import { GenericLoader } from "./GenericLoader";

export const createMarketplaceLoader = (loaderConfig) => {
    if (!loaderConfig) return null;

    const MarketplaceLoaderComponent = () => {
        const { pathname } = useLocation();
        const isDashboardRoute = pathname.startsWith('/dashboard');

        return (
            <GenericLoader
                logo={loaderConfig.logo}
                width={loaderConfig.width}
                height={loaderConfig.height}
                color={isDashboardRoute ? undefined : loaderConfig.color}
            />
        );
    };

    MarketplaceLoaderComponent.displayName = 'MarketplaceLoader';

    return MarketplaceLoaderComponent;
}; 